import React, { useState } from 'react'
import Utilities from './Utilities'
import { getCharityLogoUrl } from '../../../utils/media/cents-media'
import { useSelector } from 'react-redux'
import { RootState } from '../../../redux/store'

const UserProfile: React.FC = () => {
  const [isUtilitiesOpen, setIsUtilitiesOpen] = useState<boolean>(false)

  const username = useSelector((state: RootState) => state.auth.username)
  const charityId = useSelector((state: RootState) => state.auth.charity?._id)
  const charityName = useSelector((state: RootState) => state.auth.charity?.name)

  const toggleUtilities = () => {
    setIsUtilitiesOpen(!isUtilitiesOpen)
  }

  return (
    <div className='user-profile'>
      <Utilities isOpen={isUtilitiesOpen} />
      <div className='h-fit w-full p-5 flex justify-start items-center gap-5 bg-cents-white border-2 border-cents-grey rounded-2xl cursor-pointer' onClick={toggleUtilities}>
        <img src={getCharityLogoUrl(charityId ?? '')} className='h-6 w-auto' />
        <div className='text-left overflow-hidden'>
          <p className='font-semibold truncate text-sm text-cents-black'>{username}</p>
          <p className='font-semibold text-gray-400 text-xs mt-1'>{charityName}</p>
        </div>
      </div>
    </div>
  )
}

export default UserProfile